import { useEffect, FC } from 'react';
import { ELDFlags, EMixpanelEvent } from '../../util/constants';
import API from '../../api/api';
import { useFlags } from 'launchdarkly-react-client-sdk';
import PageLayoutV2 from '../../layout/PageLayoutV2/PageLayoutV2';
import VerifyWithPasscode from '../VerifyWithPasscode/VerifyWithPasscode';
import VerifyWithLink from '../VerifyWithLink/VerifyWithLink';
import mixpanel from 'mixpanel-browser';

export type TCreateAccountSuccessProps = {
    email: string;
    onVerifyPasscode: (code: string) => Promise<void>;
    onResendPasscode: () => Promise<void>;
    onVerifyRedirect?: string;
};

const CreateAccountSuccess: FC<TCreateAccountSuccessProps> = (props) => {
    const { email, onVerifyPasscode, onResendPasscode, onVerifyRedirect } = props;
    const { [ELDFlags.useConsumerPasscodeVerification]: usePasscodeForVerifiication } = useFlags();

    useEffect(() => {
        API.post.trackEvent({ event: 'Sign In || Verification | Check your inbox' });
        mixpanel.track(EMixpanelEvent.actionStart, { key: 'verify_account' });
    }, []);

    return (
        <PageLayoutV2>
            {usePasscodeForVerifiication ? (
                <VerifyWithPasscode
                    email={email}
                    onVerifyPasscode={onVerifyPasscode}
                    onResendPasscode={onResendPasscode}
                    onSuccessRedirect={onVerifyRedirect ? { pathname: onVerifyRedirect } : undefined}
                />
            ) : (
                <VerifyWithLink email={email} />
            )}
        </PageLayoutV2>
    );
};

export default CreateAccountSuccess;
